
<sm-misc-title-bar [headerCustomTemplate]="addButton" pageTitle={{pageTitle}} [showBackButton]="false">
    <ng-template #addButton>
      <div class="d-flex search-field">
        <mat-form-field appearance="outline" class="me-2" *ngIf="toShowInventoryItems">
          <mat-label>{{ 'services.label' | translate }}</mat-label>
          <input
          [formControl]="searchString"
           
            matInput
            placeholder="{{ 'services.placeholder' | translate }}"
            (keyup)="searchServiceData()"
          />
          <button
          
            mat-button
            *ngIf="!searchString.value"
            matSuffix
            mat-icon-button
            aria-label="Clear"
          >
            <mat-icon>search</mat-icon>
          </button>
          <button
          mat-button
          *ngIf="searchString.value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="reset()"
        >
          <mat-icon >close</mat-icon>
        </button>
        </mat-form-field>
  
        <button
        mat-icon-button
        mat-dialog-close
        class="align-self-end"
        color="accent"
      >
        <mat-icon style=" color: #000; position: relative; top: -5px;">close</mat-icon>
      </button>
      </div>
    </ng-template>
  </sm-misc-title-bar>
  <!-- inventory increase/decrease modal -->
    <mat-dialog-content *ngIf="!toShowInventoryItems && (operation_type == 1 || operation_type == 2 || operation_type == 3)" style="min-width: 400px;" >
      <div class="text-fieldss">
        <h3 style="    font-weight: 700;
        margin-bottom: 5px;">{{selectedInventoryData[0].item_name}}</h3>
        <p>{{selectedInventoryData[0].quantity_info}} {{selectedInventoryData[0].selling_unit}}</p>
        <p>Current stock: <strong>{{selectedInventoryData[0].current_purchase_stock}} {{selectedInventoryData[0].purchase_unit}}</strong> </p>
        <p>Minimum stock: <strong> {{selectedInventoryData[0].min_stock}} {{selectedInventoryData[0].purchase_unit}}</strong></p>
      </div>
      <div class="text-fieldss">
        <mat-form-field appearance="outline">
          <mat-label>Purchase quantity</mat-label>
          <input smNumericOnly
            [(ngModel)]="purchaseListData.purchase_qty"
            matInput
  
          />
         
        </mat-form-field>
        <p style="position: relative; top: -10px;">Purchase unit: <strong>{{selectedInventoryData[0].purchase_unit}}</strong></p>
      </div>
  
      <div class="chip_cont" *ngIf="operation_type != 3">
        <mat-chip-list aria-label="Fish selection" class="mb-3">
          <mat-chip
            style="height: auto"
      [ngClass]="{ selectedPurple: selectedPurchaseType == 2 }"
      (click)="changeChip(2)"
            >Reminder
          </mat-chip>
        </mat-chip-list>
      
        <mat-chip-list aria-label="Fish selection" class="mb-3">
          <mat-chip
            style="height: auto"
            [ngClass]="{ selectedPurple: selectedPurchaseType == 1 }"
      (click)="changeChip(1)"
            >Purchased
          </mat-chip>
        </mat-chip-list>
      </div>
      <div class="text-fieldss" *ngIf="selectedPurchaseType != 2">
        <mat-form-field appearance="outline">
          <mat-label>Purchase price</mat-label>
          <input smDecimalOnly type="number"
            [(ngModel)]="purchaseListData.purchase_price"
            matInput
  
          />
         
        </mat-form-field>
        <!-- <p style="position: relative; top: -10px;">Purchase unit: <strong>{{selectedInventoryData[0].purchase_unit}}</strong></p> -->
      </div>
      <div class="text-fieldss" *ngIf="selectedPurchaseType != 2">
        <mat-form-field appearance="outline">
          <mat-label>Amount paid</mat-label>
          <input smDecimalOnly type="number"
            [(ngModel)]="purchaseListData.payment_amount"
            matInput
  
          />
         
        </mat-form-field>
        <!-- <p style="position: relative; top: -10px;">Purchase unit: <strong>{{selectedInventoryData[0].purchase_unit}}</strong></p> -->
      </div>
      <div *ngIf="selectedPurchaseType == 1">
        <mat-form-field class="w-100" appearance="outline" class="col-12" (click)="picker3.open()" style="padding: 0px;">
            <mat-label>Select purchase date</mat-label>
            <input matInput [matDatepicker]="picker3" [(ngModel)]="purchaseListData.purchase_date" readonly [max]="maxDate">
            <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
            <mat-datepicker #picker3 disabled="false"></mat-datepicker>
          </mat-form-field>
    </div>
      <div class="text-fieldss">
        <mat-form-field appearance="outline">
          <mat-label>Notes</mat-label>
          <textarea
            [(ngModel)]="purchaseListData.notes"
            matInput
          ></textarea>
         
        </mat-form-field>
      </div>
      <div class="text-fieldss">
        <mat-form-field appearance="outline">
          <mat-label>Barcode</mat-label>
          <input
            [disabled]="selectedPurchaseType == 2"
            [(ngModel)]="purchaseListData.barcode"
            matInput
          />
         
        </mat-form-field>
      </div>
      
     
    </mat-dialog-content>
  
  
    <!-- inventory items -->
    <mat-dialog-content *ngIf="toShowInventoryItems" style="min-width: 80vw;">
      <div class="row" *ngIf="inventoryItems.length>0">
          <div class="col-sm-4 service_temple_card" *ngFor="let item of inventoryItems">
              <div class="fl_orders" (click)="selectInventoryTemplate(item)">
                  <div class="top_section_order">
                      <div class="row">
                          <div class="col-sm-3">
                              <div class="ads_sec">
                                  <div class="hm_icon_progr" *ngIf="item.image_thumb_url && item.image_thumb_url != 'null'">
                                      <img [src]="item.image_thumb_url">
                                  </div>
                                  <div class="hm_icon_progr" *ngIf="!item.image_thumb_url || item.image_thumb_url == 'null'">
                                      <img src="../../../../assets/images/photo.png">
                                  </div>
                              </div>
                          </div>
                          <div class="col-sm-9">
                              <div class="order_dec">
                                
                                  <div class="tick_opklads" [ngStyle]="{'background': item.selected ? '#1da942' : 'lightgrey'}" >
                                      <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
                                      <mat-icon class="material-icons-outlined" class="mb-1" style="color: #fff;">check</mat-icon
              >
                                  </div>
                                  <h3 style="-webkit-box-orient: vertical;
                                  display: -webkit-box;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                  white-space: normal;
                                  ">{{item.item_name}}</h3>
                                  <!-- <p>{{
                                    item.item_desc.length > 15
                                      ? item.item_desc.substring(0, 15) + "..."
                                      : item.item_desc
                                  }}
                                  </p> -->
                                  <!-- <p>Home: Rs.{{item.home_rate}}, Shop: Rs.{{item.shop_rate}}
                                  </p> -->
                                  <!-- <p>Quantity info: {{item.quantity_info}}
                                  </p> -->
                                  <!-- <p class="pricecls">Price: <b>Rs.</b> </p> -->
                                  <!-- <input type="text" [(ngModel)]="item.price" [disabled]="item.isDisabled == true"> -->
                                   <p
                                    class="two-line-ellipsis"
                                    [matTooltip]="item.item_desc"
                                    matTooltipPosition="above"
                                    matTooltipShowDelay="300"
                                  >
                                    {{ item.item_desc }}
                                  </p>
                               </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          
  
          <div *ngIf="datalength > inventoryItems.length" style="text-align: center;">
            <button
            style="
            width: 25%;
            border-radius: 50px;
        "
        mat-flat-button
        color="accent"
        (click)="seeMore()"
      >
        See more
      </button>
     
          </div>
          
  
      </div>
      <div class="row" *ngIf="loader">
        <div style="padding: 50px 0px; text-align: center;">
          <h2>Loading Inventory Items</h2>
        </div>
      </div>
      <div class="row" *ngIf="!loader && inventoryItems.length == 0">
        <div class="inven_sde" style="padding: 50px 0px; text-align: center;">
          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 450 450" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M364.1 445H85.9c-7.8 0-14.2-6.4-14.2-14.2V75.5c0-7.8 6.4-14.2 14.2-14.2h61.3c2.8 0 5 2.2 5 5s-2.2 5-5 5H85.9c-2.3 0-4.2 1.9-4.2 4.2v355.3c0 2.3 1.9 4.2 4.2 4.2h278.3c2.3 0 4.2-1.9 4.2-4.2V75.5c0-2.3-1.9-4.2-4.2-4.2h-61.3c-2.8 0-5-2.2-5-5s2.2-5 5-5h61.3c7.9 0 14.2 6.4 14.2 14.2v355.3c0 7.8-6.4 14.2-14.3 14.2z" fill="#a7a7a7" opacity="1" data-original="#000000" class=""></path><path d="M225 67.5c-11.1 0-20.2-9.1-20.2-20.2s9.1-20.2 20.2-20.2 20.2 9.1 20.2 20.2-9.1 20.2-20.2 20.2zm0-30.4c-5.6 0-10.2 4.6-10.2 10.2s4.6 10.2 10.2 10.2 10.2-4.6 10.2-10.2-4.6-10.2-10.2-10.2z" fill="#a7a7a7" opacity="1" data-original="#000000" class=""></path><path d="M297.6 90.2H152.4c-5.6 0-10.2-4.6-10.2-10.2V52.5c0-5.6 4.6-10.2 10.2-10.2H183c2.5-21 20.4-37.3 42-37.3s39.5 16.3 42 37.3h30.6c5.6 0 10.2 4.6 10.2 10.2V80c0 5.7-4.5 10.2-10.2 10.2zM152.4 52.3c-.1 0-.2.1-.2.2V80c0 .1.1.2.2.2h145.3c.1 0 .2-.1.2-.2V52.5c0-.1-.1-.2-.2-.2h-35.3c-2.8 0-5-2.2-5-5 0-17.8-14.5-32.3-32.3-32.3s-32.3 14.5-32.3 32.3c0 2.8-2.2 5-5 5zM274.1 232H176c-5.5 0-9.9-4.5-9.9-9.9V134c0-5.5 4.4-9.9 9.9-9.9h98.1c5.5 0 9.9 4.4 9.9 9.9v88.1c0 5.4-4.5 9.9-9.9 9.9zm0-10v5zm-98.1 0h98v-88h-98z" fill="#a7a7a7" opacity="1" data-original="#000000" class=""></path><path d="M240.7 167.9c-1 0-1.9-.3-2.8-.8l-12.9-8.5-12.9 8.5c-1.5 1-3.5 1.1-5.1.2s-2.6-2.6-2.6-4.4V129c0-2.8 2.2-5 5-5s5 2.2 5 5v24.6l7.9-5.2c1.7-1.1 3.8-1.1 5.5 0l7.9 5.2V129c0-2.8 2.2-5 5-5s5 2.2 5 5v33.9c0 1.8-1 3.5-2.6 4.4-.8.4-1.6.6-2.4.6zM120.9 295.9c-1.3 0-2.6-.5-3.5-1.5l-10.6-10.6c-1.9-2-1.9-5.1 0-7.1s5.1-2 7.1 0l7.1 7.1 21.5-21.5c1.9-2 5.1-2 7.1 0 1.9 2 1.9 5.1 0 7.1l-25 25c-1.2 1-2.5 1.5-3.7 1.5zM339.8 283.4H173.5c-2.8 0-5-2.2-5-5s2.2-5 5-5h166.2c2.8 0 5 2.2 5 5s-2.2 5-4.9 5zM120.9 348.5c-1.3 0-2.6-.5-3.5-1.5l-10.6-10.6c-1.9-2-1.9-5.1 0-7.1s5.1-2 7.1 0l7.1 7.1 21.5-21.5c1.9-2 5.1-2 7.1 0 1.9 2 1.9 5.1 0 7.1l-25 25c-1.2 1-2.5 1.5-3.7 1.5zM339.8 336H173.5c-2.8 0-5-2.2-5-5s2.2-5 5-5h166.2c2.8 0 5 2.2 5 5s-2.2 5-4.9 5zM120.9 401.2c-1.3 0-2.6-.5-3.5-1.5l-10.6-10.6c-1.9-2-1.9-5.1 0-7.1s5.1-2 7.1 0l7.1 7.1 21.5-21.5c1.9-2 5.1-2 7.1 0 1.9 2 1.9 5.1 0 7.1l-25 25c-1.2 1-2.5 1.5-3.7 1.5zM339.8 388.7H173.5c-2.8 0-5-2.2-5-5s2.2-5 5-5h166.2c2.8 0 5 2.2 5 5s-2.2 5-4.9 5z" fill="#a7a7a7" opacity="1" data-original="#000000" class=""></path></g></svg>
          <h2>No Inventory Items</h2>
        </div>
      </div>
    </mat-dialog-content>


    <!-- buttons when showing increase/decrease modal -->
    <mat-dialog-actions align="end" *ngIf="!toShowInventoryItems && (operation_type == 1 || operation_type == 2 || operation_type == 3)">
      <button mat-button (click)="back()">Back</button>
      <button
        mat-flat-button
        color="accent"
        [disabled]="
          !purchaseListData.purchase_qty || !checkDateFilled() || !checkPurchasePriceFilled()
        "
        (click)="onPost()"
      >
        {{ editMode ? "Confirm" : "Confirm" }}
      </button>
    </mat-dialog-actions>
  
  <!-- buttons when showing inventory items -->
    <mat-dialog-actions align="end" *ngIf="toShowInventoryItems">
      <button mat-button mat-dialog-close>Cancel</button>
      <button
        [disabled]="
        selectedInventoryData.length == 0
  
        "
        mat-flat-button
        color="accent"
        (click)="onSelectNext()"
      >
        Next
      </button>
    </mat-dialog-actions>

    